import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { GetWishlistDto } from '../../../dto/wishlist/getwishlist/getwishlistdto';

export interface GetWishlistResponse extends APIResponse
{
    getGetWishlistDto(): GetWishlistDto;
}

export class GetWishlistResponseDtoImpl extends APIResponseDtoImpl implements GetWishlistResponse
{
    private getWishlistDto : GetWishlistDto;

    getGetWishlistDto(): GetWishlistDto
    {
        return this.getWishlistDto;
    }
    setGetWishlistDto(getWishlistDto: GetWishlistDto)
    {
        this.getWishlistDto = getWishlistDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getwishlist/getwishlistresponse.tsx